var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import erc20Abi from '../../../../abis/erc20.json';
import { BigNumber, Contract } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctCustomArray, FctTupleArray, FctValueList } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { kiroboMulticallContracts, kiroboMulticallSimulateContracts } from '../constants';
export var Erc20TransfersCSV = createPlugin({
    protocol: 'KIROBO_MULTICALL_CSV',
    type: 'LIBRARY',
    toEns: '@lib:multicall',
    method: 'erc20Transfers',
    name: 'erc20TransfersCSV',
    supportedContracts: kiroboMulticallContracts,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    'transfers_tuple[]': new FctTupleArray({
                        params: {
                            name: new FctCustomArray({ virtual: true, required: false }),
                            token: new FctAddressList({ options: getSupportedTokens({ chainId: chainId }) }),
                            from: new FctAddressList({}),
                            to: new FctAddressList({}),
                            amount: new FctValueList({}),
                            reason: new FctCustomArray({ virtual: true, required: false }),
                        },
                    }),
                },
            },
            output: {},
        });
    },
    requiredApprovals: function (params, _chainId, _walletAddress, vaultAddress) {
        var to = params.to, methodParams = params.methodParams;
        if (!vaultAddress)
            return [];
        var value = methodParams['transfers_tuple[]'].value;
        var tokensToApprove = {};
        value === null || value === void 0 ? void 0 : value.forEach(function (nestedParam) {
            var fromParam = nestedParam.find(function (param) { return param.name === 'from'; });
            var tokenParam = nestedParam.find(function (param) { return param.name === 'token'; });
            var amountParam = nestedParam.find(function (param) { return param.name === 'amount'; });
            if (!(fromParam === null || fromParam === void 0 ? void 0 : fromParam.value))
                return;
            if (!tokenParam)
                return;
            if (vaultAddress && vaultAddress.toLowerCase() === fromParam.value.toLowerCase())
                return;
            if (!tokensToApprove[tokenParam.value]) {
                tokensToApprove[tokenParam.value] = { amount: BigNumber.from((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0'), from: fromParam === null || fromParam === void 0 ? void 0 : fromParam.value };
                return;
            }
            tokensToApprove[tokenParam.value].amount = tokensToApprove[tokenParam.value].amount.add((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0');
            return;
        });
        return Object.keys(tokensToApprove).map(function (tokenToApproveAddress) {
            var token = tokensToApprove[tokenToApproveAddress];
            return {
                to: tokenToApproveAddress,
                from: token.from,
                params: { spender: vaultAddress, amount: token.amount.toString() },
                method: 'approve',
                protocol: 'ERC20',
            };
        });
    },
    beforeSimulate: function (_a) {
        var input = _a.input, provider = _a.provider, chainId = _a.chainId;
        return __awaiter(void 0, void 0, void 0, function () {
            var methodParams, contractAddress, value, tokensToSend, multiApproveParams;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        methodParams = input.methodParams;
                        contractAddress = kiroboMulticallSimulateContracts[chainId];
                        return [4 /*yield*/, ((_b = provider === null || provider === void 0 ? void 0 : provider.signer) === null || _b === void 0 ? void 0 : _b.sendTransaction({
                                to: contractAddress,
                                value: '1' + '0'.repeat(3),
                            }))];
                    case 1:
                        _c.sent();
                        value = methodParams['transfers_tuple[]'].value;
                        tokensToSend = {};
                        value === null || value === void 0 ? void 0 : value.forEach(function (nestedParam) {
                            var tokenParam = nestedParam.find(function (param) { return param.name === 'token'; });
                            var amountParam = nestedParam.find(function (param) { return param.name === 'amount'; });
                            if (!tokenParam)
                                return;
                            if (!tokensToSend[tokenParam.value]) {
                                return (tokensToSend[tokenParam.value] = BigNumber.from((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0'));
                            }
                            return (tokensToSend[tokenParam.value] = tokensToSend[tokenParam.value].add((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0'));
                        });
                        return [4 /*yield*/, Promise.all(Object.keys(tokensToSend).map(function (key) { return __awaiter(void 0, void 0, void 0, function () {
                                var tokenContract;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            tokenContract = new Contract(key, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer);
                                            console.log({ token: key, anount: tokensToSend[key].toString() });
                                            return [4 /*yield*/, tokenContract['approve'](contractAddress, tokensToSend[key].toString(), {})];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _c.sent();
                        multiApproveParams = [];
                        multiApproveParams.push(value === null || value === void 0 ? void 0 : value.map(function (nestedParam) {
                            return nestedParam
                                .map(function (p) {
                                if (p.name === 'token')
                                    return p.value;
                                if (p.name === 'to')
                                    return contractAddress;
                                if (p.name === 'amount')
                                    return p.value;
                                return;
                            })
                                .filter(Boolean);
                        }));
                        return [2 /*return*/];
                }
            });
        });
    },
    estimateGasOnParams: function (params, method, chainId) {
        // Gas notes:
        // 36k per transfer
        var transfers = params.methodParams['transfers_tuple[]'];
        if (!transfers.value || !Array.isArray(transfers.value)) {
            return '10000';
        }
        var gas = BigNumber.from(transfers.value.length).mul(120000);
        if (chainId === '42161') {
            gas = gas.mul(13);
        }
        return gas.toString();
    },
});
